import React from "react";
import { QueryRenderer } from "@cubejs-client/react";
import { Spin } from "antd";
import { AutoComplete } from "antd";
import cubejsApi from "../../cubejsApiBQ";

const oficina = ({ resultSet, props }) => {
    var dataSource = [];
    var cedulas = [];

    resultSet.loadResponse.data.map((result, index) => {
        cedulas[index] = result["ResumenActividadCdt.identificacionAsesor"];
        return (dataSource[index] = result["ResumenActividadCdt.oficina"]);
    });

    return (
        <AutoComplete
            style={{
                width: "100%",
                marginBottom: "25px",
            }}
            disabled={true}
            allowClear
            size="large"
            dataSource={dataSource}
            placeholder="Oficina"
            defaultValue={dataSource[cedulas.indexOf(props.cedula)]}
            filterOption={(inputValue, option) => {
                return (
                    option.props.children
                        .toUpperCase()
                        .indexOf(inputValue.toUpperCase()) !== -1
                );
            }}
            onSelect={(value) => {
                props.setOficina(value);
                props.setCedula(cedulas[dataSource.indexOf(value)]);
            }}
            onSearch={() => {
                props.setOficina("");
                // props.setCedula("");
            }}
        />
    );
};

const renderChart = (Component, props) => ({ resultSet, error }) =>
    (resultSet && <Component resultSet={resultSet} props={props} />) || (
        <Spin />
    );

const Oficina = (props) => (
    <QueryRenderer
        query={{
            renewQuery: true,
            measures: [],
            timeDimensions: [],
            dimensions: [
                "ResumenActividadCdt.oficina",
                "ResumenActividadCdt.identificacionAsesor",
            ],
            segments: [],
            filters: [
                {
                    dimension: "ResumenActividadCdt.identificacionAsesor",
                    operator: "contains",
                    values: props.cedula !== "" ? [props.cedula] : [],
                },
                {
                    dimension: "Usuarios.zona",
                    operator: "contains",
                    values: props.zona !== "" ? [props.zona] : [],
                },
            ],
        }}
        cubejsApi={cubejsApi}
        render={renderChart(oficina, props)}
    />
);

export default Oficina;
